import { Button, Grid2, Table, TableBody, TableContainer, TableHead, TableRow, TableCell, Typography, Modal, Box, Switch, TextField, IconButton, Snackbar } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import ClearIcon from '@mui/icons-material/Clear';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import TokenError from "../tokenError.jsx";

const style = {
    // position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 600,
    // bgcolor: 'background.paper',
    // border: '1px solid #000',
    // boxShadow: 24,
    // p: 4,
    // borderRadius:'8px'
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        maxHeight: '80%', // Limit height to make it scrollable
        overflowY: 'auto', // Enable vertical scrolling
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '8px',
};

const HomeScreenDetails = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [bannerData, setBannerData] = useState([]);
    const location = useLocation();
    const rowData = location.state?.rowData; // Access rowData from location state
    const godData = location.state?.godData;

    const [open, setOpen] = useState(false);
    const [imageList, setImageList] = useState([]); // Store the list of images
    const [selectedFiles, setSelectedFiles] = useState([]); // Temporarily store selected files for preview
    const [deepIndexList, setDeepIndexList] = useState([]);
    const deepIndexConst = {
        "Driver Promotions Screen": 1001,
        "Refer & Earn Screen": 1005,
        "Request Screen": 1004,
        "My Rides Screen": 1003,
        "Corporate Docs Verification Screen": 1010,
        "Vehicle Docs Verification Screen": 1011,
        "All Docs Verification Screen": 1009,
    };

    const [categoryId, setCategoryId] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState(2);
    const [active, setActive] = useState(false);
    const [imageURL, setImageURL] = useState('');
    const [redirectURL, setRedirectURL] = useState('');
    const [socialMediaType, setSocialMediaType] = useState(-1);
    const [displayOrder, setDisplayOrder] = useState('');
    const [deepIndex, setDeepIndex] = useState('');
    // const [userType, setUserType] = useState(0);
    const [bannerId, setBannerId] = useState('');
    const [obcId, setobcId] = useState(0);
    const [imageUrlInput, setImageUrlInput] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false); 

    const fileInputRef = useRef(null);

    // Handle file input change with size validation
    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);

        const MAX_WIDTH = 1320;  //1312 x 520 .....&&..... 1312 x 736
        const MAX_HEIGHT = 750;
        const MIN_WIDTH = 1300;
        const MIN_HEIGHT = 500;

        const VID_MAX_WIDTH = 890;  //880 x 400
        const VID_MAX_HEIGHT = 410;
        const VID_MIN_WIDTH = 870;
        const VID_MIN_HEIGHT = 390;

        const validFiles = [];

        for (const file of files) {
            const { width, height } = await checkDimensions(file);

            if ((width > VID_MAX_WIDTH || height > VID_MAX_HEIGHT) && type==2) {
                setMessage(`Image (${width}x${height}) too large. Please choose another file having maximum dimensions of ${VID_MAX_WIDTH} x ${VID_MAX_HEIGHT} px.`);
                showSnackbar(true);
                fileInputRef.current.value = null;
                continue;
            }

            if ((width < VID_MIN_WIDTH || height < VID_MIN_HEIGHT) && type==2) {
                setMessage(`Image (${width}x${height}) too small. Please choose another file having minimum dimensions of ${VID_MIN_WIDTH} x ${VID_MIN_HEIGHT} px.`);
                showSnackbar(true);
                fileInputRef.current.value = null;
                continue;
            }

            if ((width > MAX_WIDTH || height > MAX_HEIGHT) && type!=2) {
                setMessage(`Image (${width}x${height}) too large. Please choose another file having maximum dimensions of ${MAX_WIDTH} x ${MAX_HEIGHT} px.`);
                showSnackbar(true);
                fileInputRef.current.value = null;
                continue;
            }

            if ((width < MIN_WIDTH || height < MIN_HEIGHT) && type!=2) {
                setMessage(`Image (${width}x${height}) too small. Please choose another file having minimum dimensions of ${MIN_WIDTH} x ${MIN_HEIGHT} px.`);
                showSnackbar(true);
                fileInputRef.current.value = null;
                continue;
            }

            // Passed validation
            validFiles.push({
                file,
                previewURL: URL.createObjectURL(file),
            });
        }

        // Update selected files with only valid ones
        setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
        
    };

    // Check image dimensions
    const checkDimensions = (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = function() {
                const width = this.width;
                const height = this.height;
                resolve({ width, height });
            };
            img.src = URL.createObjectURL(file);
        });
    };
    const handleAddImages = async () => {
        if (selectedFiles.length === 0) {
            alert("Please select images to upload.");
            return;
        }
    
        const uploadedUrls = [];
    
        for (const validFile of selectedFiles) {
            const formData = new FormData();
            formData.append("image", validFile.file);
            const url = operationsUrl + '/upload_image';
    
            try {
                const response = await axios.post(url, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
    
                const s3Url = response.data.url;
                uploadedUrls.push(s3Url);
                fileInputRef.current.value = null;
            } catch (error) {
                console.error("Error uploading image:", error);
                alert("Error uploading one or more images.");
            }
        }
    
        // Update final image list with new uploaded URLs
        setImageList((prevList) => [...prevList, ...uploadedUrls]);
    
        // Clear selected file previews
        setSelectedFiles([]);
    };

    const handleRemoveImage = async(index) => {
        setImageList((prevList) => prevList.filter((_, imgIndex) => imgIndex !== index));
        const imageToDelete = imageList[index];
        // const url = operationsUrl + '/delete_image';
        if (!imageToDelete) {
            console.error('No image to delete');
            return;
        }
        // try {
        //     await axios.delete(url, {
        //         data: {
        //             url: imageToDelete, // Pass the S3 URL here
        //         },
        //     });
        // } catch (error) {
        //     console.error('Error deleting image:', error);
        // }
    };

    if(godData){
        for(let i=0;i<godData.length;i++){
            if(godData[i].id == categoryId){
                var needTitle = godData[i].need_title;
                var needDescription  = godData[i].need_description;
                var numberOfImages = godData[i].no_of_images;
            }
        }
    }
    useEffect(() => {
        if (!rowData) {
            setError('No data available');
            return;  // Prevent API call if rowData is not available
        }
        setCategoryId(rowData.category_id);
        setobcId(rowData.id);
        fetchBanner();
    }, [rowData]);

    const fetchBanner = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const queryParams = new URLSearchParams({
                token: token,
                category_id: rowData.id,
                timestamp: timestamp
            }).toString();

            const url = `${serverUrl}/panel/get_home_screen_banners?${queryParams}`;

            const response = await fetch(url);
            const data = await response.json();
            console.log('data', data);

            if (data.flag == 200) {
                setBannerData(data.data || []);
            } 
            else if(data.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setError(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    };

    if (error) {
        return <Typography>{error}</Typography>;
    }

    if (!rowData) {
        return <Typography>No data available</Typography>;
    }

    const handleOpen = (row) => {
        if(row && row.id) {
            setDisplayOrder(row.display_order);
            setRedirectURL(row.redirect_url);
            setActive(row.is_active==1);
            setSocialMediaType(row.social_media_type);
            setType(row.type);
            setTitle(row.title);
            setDescription(row.description);
            const imageArray = row.image_url.split(';');
            setImageList(imageArray);
            setBannerId(row.id);
            setobcId(row.obc_id);

            const deepIdxArr = (row.deep_index).split(',');
            const objIdx = deepIdxArr.map((id) => {
                const name = Object.keys(deepIndexConst).find((key) => deepIndexConst[key] === Number(id));
                return name!=undefined ? { id: Number(id), name } : {};
            });
            setDeepIndexList(objIdx);
        }
        else{
            // console.log('rowData.obc_id', rowData.id);
            setDeepIndex('');
            setDisplayOrder('');
            setRedirectURL('');
            setActive(false);
            // setUserType(0);
            setSocialMediaType(-1);
            setType(2);
            setTitle('');
            setDescription('');
            setImageList([]);
            setDeepIndexList([]);
            setBannerId('');
            setImageUrlInput('');
            setobcId(rowData.id);
        }
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    const saveBanner = async (val) => {
        if(type=='' || type==null){
            setMessage('Type is required.');
            showSnackbar(true);
            return;
        }
        if(displayOrder=='' || displayOrder==null){
            setMessage('Display order is required.');
            showSnackbar(true);
            return;
        }

        let l= imageList.length;

        if(imageUrlInput && l<numberOfImages){
            imageList.push(imageUrlInput);
        }
        const imageUrls = imageList.join(";");
        if(l<numberOfImages && numberOfImages>1){
            // alert('Please upload '+numberOfImages+' images');
            setMessage('You are required to upload '+numberOfImages+' images.');
            showSnackbar(true);
            setImageUrlInput('');
            return;
        }
        if(l<numberOfImages && numberOfImages==1){
            // alert('Please upload '+numberOfImages+' images');
            setMessage('You are required to upload the image.');
            showSnackbar(true);
            setImageUrlInput('');
            return;
        }
        let deepIdxArray = [];
        for(let i=0;i<deepIndexList.length;i++){
            deepIdxArray.push(deepIndexList[i].id); 
        }
        const deepIdxStr = deepIdxArray.join(',');

        try {
            const token = localStorage.getItem('token');
            const body = {
                token: token,
                obc_id: obcId,
                title: title,
                description: description,
                type: type,
                is_active: active===true ? 1 : 0, 
                display_order: displayOrder,
                image_url: imageUrls!="" ? imageUrls : imageUrlInput,
                redirect_url: redirectURL ? redirectURL : '',
                deep_index: deepIdxStr ? deepIdxStr : '',
                social_media_type: type==1 ? socialMediaType : '-1'
            };
            // if(socialMediaType){
            //     body.social_media_type = socialMediaType ? socialMediaType : '-1';
            // }
            if(bannerId!=0){
                body.banner_id = bannerId;
            }
            const response = await fetch(operationsUrl + '/panel/create_and_update_home_screen_banners', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (data.flag==200) {
                handleClose();
                fetchBanner();
                showSnackbar(true);
                setMessage(data.message);
            } 
            else {
                showSnackbar(true);
                setMessage(data.message);
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    };

    const handleAddDeepIndex = (selectedValue) => {
        const selectedName = Object.keys(deepIndexConst).find(
          (key) => deepIndexConst[key] === selectedValue
        );
        if (deepIndexList.some((item) => item.id === selectedValue)) {
            alert("Deep Index already added!");
            return;
        }
        setDeepIndexList((prevList) => [
            ...prevList,
            { id: selectedValue, name: selectedName },
        ]);
    };
    
    // Remove a deep index
    const handleRemoveDeepIndex = (index) => {
        setDeepIndexList((prevList) =>
          prevList.filter((_, idx) => idx !== index)
        );
    };

    // const handleAddImageUrl = () => {
    //     if (imageUrlInput) {
    //         setImageList(prevList => [...prevList, imageUrlInput]);
    //         setImageUrlInput('');
    //     }
    // };
    const handleAddImageUrl = () => {
        if (!imageUrlInput) return;
    
        const img = new Image();
        img.src = imageUrlInput;
    
        img.onload = () => {
            const width = img.width;
            const height = img.height;
    
            console.log(`Image dimensions: ${width} x ${height}`);

            const MAX_WIDTH = 1320;  //1312 x 520 .....&&..... 1312 x 736
            const MAX_HEIGHT = 750;
            const MIN_WIDTH = 1300;
            const MIN_HEIGHT = 500;

            const VID_MAX_WIDTH = 890;  //880 x 400
            const VID_MAX_HEIGHT = 410;
            const VID_MIN_WIDTH = 870;
            const VID_MIN_HEIGHT = 390;


            if ((width > VID_MAX_WIDTH || height > VID_MAX_HEIGHT) && type==2) {
                setMessage(`Image (${width}x${height}) too large. Please choose another file having maximum dimensions of ${VID_MAX_WIDTH} x ${VID_MAX_HEIGHT} px.`);
                showSnackbar(true);
                setImageUrlInput('');
                return;
            }

            if ((width < VID_MIN_WIDTH || height < VID_MIN_HEIGHT) && type==2) {
                setMessage(`Image (${width}x${height}) too small. Please choose another file having minimum dimensions of ${VID_MIN_WIDTH} x ${VID_MIN_HEIGHT} px.`);
                showSnackbar(true);
                setImageUrlInput('');
                return;
            }

            if ((width > MAX_WIDTH || height > MAX_HEIGHT) && type!=2) {
                setMessage(`Image (${width}x${height}) too large. Please choose another file having maximum dimensions of ${MAX_WIDTH} x ${MAX_HEIGHT} px.`);
                showSnackbar(true);
                setImageUrlInput('');
                return;
            }

            if ((width < MIN_WIDTH || height < MIN_HEIGHT) && type!=2) {
                setMessage(`Image (${width}x${height}) too small. Please choose another file having minimum dimensions of ${MIN_WIDTH} x ${MIN_HEIGHT} px.`);
                showSnackbar(true);
                setImageUrlInput('');
                return;
            }
    
            // Now you can add the image to the list after checking
            setImageList(prevList => [...prevList, imageUrlInput]);
            setImageUrlInput('');
        };
    
        img.onerror = () => {
            showSnackbar(true);
            setMessage("Failed to load image. Please enter a valid URL.");
            console.error("Failed to load image. Invalid URL or network error.");
        };
    };
    

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {/* <Navbar/>
            <div className='App'>
                <Sidemenu/>
                <div className='content'> */}
                {tokenExpired && <TokenError/>}
                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>HomeScreen Details</Typography>

                    <Grid2 item sx={{marginTop:'2%'}}>
                        <Button 
                        onClick={handleOpen} 
                        variant="contained"
                            sx={{
                                backgroundColor: 'black', color: 'white', border: '1px solid black',
                                textTransform: 'none', borderRadius: '8px', width: 'auto', minWidth: '120px',
                                '&:hover': { backgroundColor: 'white', color: 'black'}
                            }}>
                                Add
                        </Button>

                            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                                <Box sx={style}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2">
                                        Add Data
                                    </Typography>
                                    <hr/>
                                    <Grid2 id="modal-modal-description" sx={{ mt: 2 }}>
                                        {
                                            needTitle!==0 ? 
                                            (<Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                                <Grid2 item size={4}>
                                                    <Typography>Title</Typography>
                                                </Grid2>
                                                <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                <Grid2 item size={6}>
                                                    <TextField size="small"
                                                        value={title}
                                                        onChange={(e) => setTitle(e.target.value)}
                                                        sx={{ width: '350px', height:'30px', marginLeft:'4%' }}
                                                    />
                                                </Grid2>
                                            </Grid2>) : ('')
                                        }
                                       
                                        {
                                            needDescription!==0 ?
                                            (
                                                <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                                    <Grid2 item size={4}>
                                                        <Typography>Description</Typography>
                                                    </Grid2>
                                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                    <Grid2 item size={6}>
                                                        <TextField size="small"
                                                            value={description}
                                                            onChange={(e) => setDescription(e.target.value)}
                                                            sx={{ width: '350px', height:'30px', marginLeft:'4%' }}
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                            ) : ('')
                                        }
                                        

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4}>
                                                <Typography>Type</Typography>
                                            </Grid2>
                                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                            <Grid2 item size={6}>
                                                <select style={{width:'350px', height:'40px', marginLeft:'4%'}}
                                                value={type} onChange={(e) => setType(e.target.value)}>
                                                    <option value="1">Browser Redirectiion</option>
                                                    <option value="2">Youtube Video</option>
                                                    <option value="3">App Link</option>
                                                    <option value="4">Banner</option>
                                                </select>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4}>
                                                <Typography>Number Of Images</Typography>
                                            </Grid2>
                                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                            <Grid2 item size={6} sx={{marginLeft:'2%'}}>
                                                {numberOfImages}
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4}>
                                                <Typography sx={{marginTop:'1%'}}>Active</Typography>
                                            </Grid2>
                                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                            <Grid2 item size={6}>
                                                <Switch checked={active} onChange={(e) => setActive(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4}>
                                                <Typography>Image URL</Typography>

                                                {(type!=2) && (
                                                    <Grid2 item xs={12} sx={{marginTop:'2%'}}>
                                                        <Typography sx={{fontSize:'12px',color:'gray'}}>*Image size should be - <br/> min: (1300 x 500)px, max : (1320 x 750)px</Typography>
                                                    </Grid2>
                                                )}

                                                {(type==2) &&(
                                                    <Grid2 item xs={12} sx={{marginTop:'2%'}}>
                                                        <Typography sx={{fontSize:'12px', color:'gray'}}>*Image size should be - <br/> min: (870 x 390)px, max : (890 x 410)px</Typography>
                                                    </Grid2>
                                                )}
                                                <Grid2 item xs={12} sx={{marginTop:'2%'}}>
                                                    <Typography sx={{fontSize:'12px', color:'gray'}}>*Please upload the image in .png, .jpg, .jpeg format</Typography>
                                                </Grid2>

                                            </Grid2>
                                            <Grid2 item size={1}><Typography>:</Typography></Grid2>
                                            <Grid2 item size={6}>
                                                <Grid2 container spacing={2}>
                                                    {/* File Input */}
                                                    {imageList.length >= 0 && imageList.length < numberOfImages && (
                                                        <Grid2 item xs={12} sx={{marginLeft:'4%'}}>
                                                            <input
                                                                type="file"
                                                                accept=".jpg, .jpeg, .png"
                                                                multiple
                                                                onChange={handleFileChange}
                                                                ref={fileInputRef}
                                                                style={{ marginBottom: "10px" }}
                                                            />
                                                        </Grid2>
                                                    )}

                                                    {/* Input for manual Image URL */}
                                                    {imageList.length < numberOfImages && (
                                                        <Grid2 item xs={12} sx={{marginLeft:'4%', display:'flex'}}>
                                                            <TextField
                                                                label="Enter Image URL"
                                                                variant="outlined"
                                                                fullWidth
                                                                value={imageUrlInput}
                                                                onChange={e => setImageUrlInput(e.target.value)}
                                                                onKeyDown={e => e.key === 'Enter' && handleAddImageUrl(e)}
                                                            />
                                                            {imageUrlInput && (
                                                                <button style={{marginTop:'2%', marginLeft:'4%', backgroundColor:'rgb(25, 118, 210)', borderColor:'none', width:'100px'}} onClick={() => handleAddImageUrl(imageUrlInput)}>Add</button>
                                                            )}
                                                        </Grid2>
                                                    )}

                                                    {/* Add Images Button */}
                                                    {imageList.length >= 0 && imageList.length < numberOfImages && selectedFiles.length!=0 &&(
                                                        <Grid2 item xs={12} sx={{marginLeft:'4%'}}>
                                                            <Button sx={{textTransform:'none', backgroundColor:'#4f95c4'}}
                                                                variant="contained" size="small"
                                                                onClick={handleAddImages}
                                                                disabled={selectedFiles.length === 0}
                                                            >
                                                                Upload Image
                                                            </Button>
                                                        </Grid2>

                                                    )}

                                                    {/* Uploaded Images Display */}
                                                    {imageList.length > 0 && (
                                                        <Grid2 item xs={12} sx={{marginLeft:'4%'}}>
                                                            <Grid2 container spacing={2}>
                                                                {imageList.map((url, index) => (
                                                                    <Grid2 item key={index}>
                                                                    <img
                                                                        src={url}
                                                                        alt={`Uploaded ${index}`}
                                                                        style={{
                                                                        width: "50px",
                                                                        height: "50px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px",
                                                                        }}
                                                                    />
                                                                    <button
                                                                        onClick={() => handleRemoveImage(index)}
                                                                        style={{color: "white", padding: "3px 6px",
                                                                            backgroundColor: "rgba(0,0,0,0.54)",
                                                                            borderRadius: "50%", border: "none", cursor: "pointer",
                                                                        }}>
                                                                        x
                                                                    </button>
                                                                    </Grid2>
                                                                ))}
                                                            </Grid2>
                                                        </Grid2>
                                                    )}
                                                        
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4}>
                                                <Typography>Redirect URL</Typography>
                                            </Grid2>
                                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                            <Grid2 item size={6}>
                                                <TextField size="small"
                                                    value={redirectURL}
                                                    onChange={(e) => setRedirectURL(e.target.value)}
                                                    sx={{ width: '350px', height:'30px', marginLeft:'4%' }}
                                                />
                                            </Grid2>
                                        </Grid2>

                                        {
                                            type==1 ? 
                                            (
                                                <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                                    <Grid2 item size={4}>
                                                        <Typography>Social Media Type</Typography>
                                                    </Grid2>
                                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                                    <Grid2 item size={6}>
                                                        <select style={{width:'350px', height:'40px', marginLeft:'4%'}}
                                                        value={socialMediaType} onChange={(e) => setSocialMediaType(e.target.value)}>
                                                            <option value="-1">Select Social Media Type</option>
                                                            <option value="1">Instagram</option>
                                                            <option value="2">Facebook</option>
                                                        </select>
                                                    </Grid2>
                                                </Grid2>
                                            ) : ('')
                                        }
                                        

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4}>
                                                <Typography>Display Order<span style={{color:'red'}}>*</span></Typography>
                                            </Grid2>
                                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                            <Grid2 item size={6}>
                                                <TextField size="small"
                                                    value={displayOrder}
                                                    onChange={(e) => setDisplayOrder(e.target.value)}
                                                    sx={{ width: '350px', height:'30px', marginLeft:'4%' }}
                                                />
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item container size={12} sx={{ marginTop:'4%'}}>
                                            <Grid2 item size={4} sx={{marginTop:'2%'}}>
                                                <Typography>Deep Index</Typography>
                                            </Grid2>
                                            <Grid2 item size={1} sx={{marginTop:'2%'}}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                            <Grid2 item size={6}>
                                                {/* <TextField size="small"
                                                    value={deepIndex}
                                                    onChange={(e) => setDeepIndex(e.target.value)}
                                                    sx={{ width: '300px', height:'30px', marginLeft:'4%' }}
                                                /> */}
                                                {deepIndexList[0]?.id && 
                                                    <ul>
                                                        {deepIndexList.map((item, index) => (
                                                            <li key={index} style={{marginTop:'4%'}}>
                                                            {item.name}{" "}
                                                            <span
                                                                onClick={() => handleRemoveDeepIndex(index)}
                                                                style={{
                                                                cursor: "pointer",
                                                                color: "white",
                                                                marginLeft: "8px", backgroundColor:'#b5b2b1', borderRadius:'50%', paddingLeft:'6px', paddingRight:'6px', paddingBottom:'2px'
                                                                }}
                                                            >
                                                                x
                                                            </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                }
                                                
                                                <select
                                                    onChange={(e) => handleAddDeepIndex(Number(e.target.value))}
                                                    defaultValue=""  style={{width:'350px', height:'40px', marginLeft:'4%'}}
                                                    >
                                                    <option value="" disabled>
                                                        Select Deep Index
                                                    </option>
                                                    {Object.entries(deepIndexConst).map(([key, value]) => (
                                                        <option key={value} value={value}>
                                                        {key}
                                                        </option>
                                                    ))}
                                                </select>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 container spacing={12} sx={{marginLeft:'20%', marginTop:'6%'}}>
                                            <Grid2 item ><Button variant="contained" sx={{width:'120px'}} onClick={saveBanner}>Save</Button></Grid2>
                                            <Grid2 item ><Button onClick={handleClose} variant="contained" color="error"  sx={{width:'120px'}}>Cancel</Button></Grid2>
                                        </Grid2>
                                    </Grid2>
                                </Box>
                            </Modal>
                    </Grid2>
                    <Grid2 className="mainBox" sx={{marginTop:'2%'}}>
                        <TableContainer className="table-container">
                            <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header">Title</TableCell>
                                        <TableCell align="center" className="table-header">Description</TableCell>
                                        <TableCell align="center" className="table-header">Type</TableCell>
                                        <TableCell align="center" className="table-header">Number of Images</TableCell>
                                        <TableCell align="center" className="table-header">Active</TableCell>
                                        <TableCell align="center" className="table-header">Image URL</TableCell>
                                        <TableCell align="center" className="table-header">Redirect URL</TableCell>
                                        <TableCell align="center" className="table-header">Social Media Type</TableCell>
                                        <TableCell align="center" className="table-header">Display Order</TableCell>
                                        <TableCell align="center" className="table-header">Deep Index</TableCell>
                                        <TableCell align="center" className="table-header">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {bannerData && bannerData.length > 0 ? (
                                        bannerData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.title || '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.description || '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.type === 1 ? 'Browser Redirection' : (row.type === 2 ? 'Youtube Video' : (row.type === 3 ? 'App Link' : 'Banner')) || '-'}
                                                </TableCell>

                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {numberOfImages || '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.is_active === 1 ? 'Yes' : 'No' || '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px',justifyContent:'center' }}>
                                                        {row.image_url
                                                            ? row.image_url.split(';').map((url, index) => (
                                                                <img
                                                                    key={index}
                                                                    src={url.trim()}
                                                                    alt={`Image ${index}`}
                                                                    style={{
                                                                        width: '50px',
                                                                        height: '50px',
                                                                        objectFit: 'cover',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #ccc',
                                                                    }}
                                                                />
                                                            ))
                                                            : '-'}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.redirect_url || '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.social_media_type === 1
                                                        ? 'Instagram'
                                                        : row.social_media_type === 2
                                                        ? 'Facebook'
                                                        : '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '120px' }}>
                                                    {row.display_order || '-'}
                                                </TableCell>
                                                <TableCell align="center" sx={{ width: 'auto', minWidth: '140px' }}>
                                                    <ul style={{ padding: 0, margin: 0, listStyle: 'disc' }}>
                                                        {row.deep_index
                                                            ? row.deep_index.split(',').map((id) => {
                                                                const name = Object.keys(deepIndexConst).find(
                                                                    (key) => deepIndexConst[key] === Number(id)
                                                                );
                                                                return (
                                                                    name && (
                                                                        <li key={id} style={{ marginBottom: '4px' }}>
                                                                            {name}
                                                                        </li>
                                                                    )
                                                                );
                                                            })
                                                            : '-'}
                                                    </ul>
                                                </TableCell>
                                                <TableCell align="center" sx={{width:'auto', minWidth:'120px'}}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => handleOpen(row)}
                                                        sx={{
                                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                            borderRadius: '8px', padding:'8%', minWidth:'40px', boxShadow:'none',
                                                            '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                            '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                        }}>

                                                    {/* <Typography sx={{marginRight:'8%'}}>Edit</Typography> */}
                                                        {/* <img src={editIcon} alt="Edit" style={{padding:"0px"}}/> */}
                                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                            <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                                        </svg>
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={11} align="center">No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid2>
                {/* </div>
            </div> */}
            <Snackbar open={snackbar} autoHideDuration={5000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    )
}

export default HomeScreenDetails;